import { CreditCard, Landmark } from "lucide-react";

/**
 * Chip visual del método de pago usado en una orden. Aparece en el detalle
 * del pedido (comprador, vendedor y admin), el recibo del ledger, la vista
 * de liberación de pagos y los listados admin — así, al ver una orden con
 * `payphone_fee = 0`, queda claro por qué es cero (transferencia) y no un bug.
 *
 * Feb 2026: creado tras el trabajo de reconciliación de método, cuando el
 * campo `payment_method` ya está garantizado a nivel de orden.
 *
 * @param {"payphone"|"transfer"|string|null|undefined} method
 * @param {"sm"|"md"} size
 */
export function PaymentMethodBadge({ method, size = "md" }) {
  const m = (method || "").toLowerCase();
  const isTransfer = m === "transfer";
  const isPayphone = m === "payphone";
  if (!isTransfer && !isPayphone) return null;

  const pad = size === "sm" ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-xs";
  const iconSize = size === "sm" ? 10 : 12;
  const label = isTransfer ? "Transferencia bancaria" : "Tarjeta (Payphone)";
  const cls = isTransfer
    ? "bg-blue-500/10 border-blue-500/30 text-blue-300"
    : "bg-purple-500/10 border-purple-500/30 text-purple-300";

  return (
    <span
      data-testid={`payment-method-badge-${isTransfer ? "transfer" : "payphone"}`}
      className={`inline-flex items-center gap-1 rounded border ${cls} ${pad} font-medium whitespace-nowrap`}
      title={`Método de pago: ${label}`}
    >
      {isTransfer ? <Landmark size={iconSize} /> : <CreditCard size={iconSize} />}
      {label}
    </span>
  );
}

/** Etiqueta corta ("Tarjeta" / "Transferencia") para tablas apretadas. */
export function paymentMethodShort(method) {
  const m = (method || "").toLowerCase();
  if (m === "transfer") return "Transferencia";
  if (m === "payphone") return "Tarjeta";
  return "";
}
